import type { ForwardRefRenderFunction } from 'react';
import type { HoverableDropzoneProps } from './HoverableDropzone';
import { forwardRef, lazy, Suspense } from 'react';

// Dynamic imports based on environment
const HoverableDropzone = lazy(() =>
  import('shared/components/Sales/HoverableDropzone').then((module) => ({
    default: module.default || module
  }))
);

const SalesImage = lazy(() =>
  import('shared/components/Sales/SalesImage').then((module) => ({
    default: module.default || module
  }))
);

const ConditionalImageRef: ForwardRefRenderFunction<HTMLImageElement, HoverableDropzoneProps> = (
  props,
  _ref
) => {
  const isDashboard = process.env['APP_TYPE'] === 'dashboard';

  return (
    <Suspense fallback={<div>Loading...</div>}>
      {isDashboard ? <HoverableDropzone {...props} /> : <SalesImage {...props} />}
    </Suspense>
  );
};

export const ConditionalImage = forwardRef(ConditionalImageRef);
ConditionalImage.displayName = 'ConditionalImage';
